var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddWalletMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    stroke: "black",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33329 9.92183V6.74266C3.33329 5.70266 3.97746 4.771 4.94996 4.4035L11.9108 1.77516C13.0016 1.36433 14.1666 2.16933 14.1666 3.33516V6.12683M8.88496 17.5002H15C16.375 17.5002 17.5 16.3752 17.5 15.0002V8.62599C17.5 7.24516 16.3808 6.126 15 6.126H4.99996C4.07913 6.126 3.33329 6.87183 3.33329 7.79266V10.2143M6.24996 11.9227V15.5785M8.07746 13.7502H4.42246M14.3741 11.751C14.2591 11.7518 14.1666 11.8452 14.1666 11.9602C14.1666 12.0752 14.26 12.1685 14.375 12.1677C14.49 12.1677 14.5833 12.0743 14.5833 11.9593C14.5833 11.8443 14.49 11.751 14.3741 11.751ZM6.24996 18.3335C3.71913 18.3335 1.66663 16.281 1.66663 13.7502C1.66663 11.2193 3.71913 9.16683 6.24996 9.16683C8.78163 9.16683 10.8333 11.2193 10.8333 13.7502C10.8333 16.281 8.78163 18.3335 6.24996 18.3335Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWalletMoneyIcon);
export default __webpack_public_path__ + "static/media/add-wallet-money-icon.c5149587707f98ce695de902dfd537cc.svg";
export { ForwardRef as ReactComponent };